const MarketShareRouter = () => import('@/features/market-share/views/MarketShareRouterView.vue')
const MarketShareIndex = () => import('@/features/market-share/views/MarketShareIndexView.vue')

// Children of ViewAuthenticated for home, help, custom reports, and market share
export const miscRoutes = [
    {
        path: 'home',
        component: () => import('@/views/HomeView.vue'),
        meta: { title: 'home' },
    },
    {
        path: 'custom-reports',
        components: {
            default: () => import('@/features/custom-report/views/CustomReportRouterView.vue'),
        },
        children: [
            {
                path: '',
                components: {
                    default: () => import('@/features/custom-report/views/CustomReportIndexView.vue'),
                },
                name: 'custom-reports-index',
            },
            {
                path: ':embed',
                components: {
                    default: () => import('@/features/custom-report/views/CustomReportEmbedView.vue'),
                },
                name: 'custom-reports-embed',
            },
        ],
    },
    {
        path: '/market-share',
        component: MarketShareRouter,
        meta: { title: 'Market Share' },
        children: [
            {
                path: '',
                name: 'market-share',
                component: MarketShareIndex,
            },
        ],
    },
    {
        path: 'help',
        component: () => import('@/views/HelpView.vue'),
        meta: { title: 'Help' },
    },
]
